<template>
  <div class="row">
    <div class="col-lg-12 col-xxl-12">
      <b-card no-body>
        <b-tabs card>
          <b-tab title="ข้อมูลบริษัท" active>
            <!-- การ์ด: ข้อมูลบริษัท (แก้ไขชื่อ / โลโก้) -->
            <div class="card card-custom gutter-b">
              <div class="card-header border-0 pt-6">
                <h3 class="card-title align-items-start flex-column">
                  <span class="card-label font-weight-bolder text-dark">
                    {{ $t("PAGE.COMPANY_MANAGEMENT.FORM.SECTION_COMPANY") }}
                  </span>
                </h3>
              </div>
              <div class="card-body pb-6 pt-0">
                <div class="col-lg-11">
                  <b-form @submit.stop.prevent="onSubmit">
                    <b-row
                      v-if="preview || preview_image != null"
                      class="mb-4 align-items-center"
                    >
                      <b-col sm="2"></b-col>
                      <b-col sm="10">
                        <div v-if="preview">
                          <img class="logo-image-preview" :src="preview" />
                        </div>
                        <div v-else-if="preview_image != null">
                          <img
                            class="logo-image-preview"
                            :src="this.preview_image"
                          />
                        </div>
                      </b-col>
                    </b-row>

                    <b-row class="mb-4">
                      <b-col sm="2">
                        <label>
                          <h5>
                            {{
                              $t(
                                "PAGE.COMPANY_MANAGEMENT.FORM.FIELDS.LOGO_IMAGE"
                              )
                            }}
                          </h5>
                        </label>
                      </b-col>
                      <b-col sm="10">
                        <b-form-file
                          id="logo_image"
                          name="logo_image"
                          type="file"
                          v-model="$v.form.logo_image.$model"
                          accept="image/*"
                          @change="loadFile($event)"
                          placeholder="No logo image chosen"
                          :state="validateState('logo_image')"
                          aria-describedby="logo_image-live-feedback"
                        ></b-form-file>
                        <b-form-invalid-feedback id="logo_image-live-feedback">
                          <span
                            v-if="!$v.form.logo_image.required"
                            class="error"
                          >
                            {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                          </span>
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>

                    <b-row class="mb-4">
                      <b-col sm="2">
                        <label>
                          <h5>
                            {{ $t("PAGE.COMPANY_MANAGEMENT.FORM.FIELDS.NAME") }}
                          </h5>
                        </label>
                      </b-col>
                      <b-col sm="10">
                        <b-form-input
                          id="name-input"
                          name="name-input"
                          type="text"
                          v-model="$v.form.name.$model"
                          :state="validateState('name')"
                          aria-describedby="name-live-feedback"
                        ></b-form-input>

                        <b-form-invalid-feedback id="name-live-feedback">
                          <span v-if="!$v.form.name.required" class="error">
                            {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                          </span>
                          <span v-if="!$v.form.name.maxLength" class="error">
                            {{
                              $t("PAGE.DEFAULT.FORM.VALIDATION.MAX_LENGTH", {
                                max: 256
                              })
                            }}
                          </span>
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>

                    <b-row class="mb-4">
                      <b-col sm="2">
                        <label>
                          <h5>รูปแบบการอัปโหลด</h5>
                        </label>
                      </b-col>
                      <b-col sm="10">
                        <b-form-radio-group
                          v-model="form.is_transfer_slip"
                          :options="uploadModeOptions"
                          name="is_transfer_slip"
                          stacked
                        />
                        <p class="text-muted small mb-0">
                          ใบเสร็จ: ลูกค้าเลือกประเภทใบเสร็จและรหัส —
                          สลิปโอนเงิน: อัปโหลดรูปสลิปอย่างเดียว
                        </p>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col sm="12">
                        <b-button
                          class="float-right"
                          @click.prevent="cancel()"
                          >{{ $t("PAGE.DEFAULT.FORM.BTN_CANCEL") }}</b-button
                        >
                        <b-button
                          type="submit"
                          variant="primary"
                          class="float-right mr-3"
                          >{{ $t("PAGE.DEFAULT.FORM.BTN_SUBMIT") }}</b-button
                        >
                      </b-col>
                    </b-row>
                  </b-form>
                </div>
              </div>
            </div>
          </b-tab>

          <b-tab title="แพ็กเกจ">
            <!-- การ์ด: แพ็กเกจ (แยกฟอร์ม — บันทึกแผนไม่กระทบข้อมูลบริษัท) -->
            <div class="card card-custom gutter-b mt-4">
              <div class="card-header border-0 pt-6">
                <h3 class="card-title align-items-start flex-column">
                  <span class="card-label font-weight-bolder text-dark">
                    {{ $t("PAGE.COMPANY_MANAGEMENT.FORM.SECTION_PLAN") }}
                  </span>
                </h3>
              </div>
              <div class="card-body pb-6 pt-0">
                <div class="col-lg-11">
                  <p class="text-muted small mb-3">
                    {{ $t("PAGE.COMPANY_MANAGEMENT.FORM.PLAN_HINT") }}
                  </p>

                  <b-form @submit.stop.prevent="onPlanFormSubmit">
                    <b-row class="mb-0">
                      <b-col sm="2">
                        <label>
                          <h5>
                            {{ $t("PAGE.COMPANY_MANAGEMENT.FORM.FIELDS.PLAN") }}
                          </h5>
                        </label>
                      </b-col>
                      <b-col sm="10">
                        <b-form-select
                          v-model="selectedPlanId"
                          :options="planSelectOptions"
                          :disabled="planLoading"
                        />
                        <b-form-input
                          v-model="planExpiresAt"
                          type="date"
                          class="mt-3"
                          :placeholder="
                            $t(
                              'PAGE.COMPANY_MANAGEMENT.FORM.FIELDS.PLAN_EXPIRES'
                            )
                          "
                        />
                        <template v-if="id > 0">
                          <b-button
                            type="submit"
                            variant="outline-primary"
                            class="mt-3"
                            :disabled="planLoading || !selectedPlanId"
                          >
                            {{
                              $t("PAGE.COMPANY_MANAGEMENT.FORM.BTN_SAVE_PLAN")
                            }}
                          </b-button>
                        </template>
                        <p v-else class="text-muted small mt-3 mb-0">
                          {{
                            $t(
                              "PAGE.COMPANY_MANAGEMENT.FORM.PLAN_ON_CREATE_HINT"
                            )
                          }}
                        </p>
                      </b-col>
                    </b-row>
                  </b-form>
                </div>
              </div>
            </div>
          </b-tab>

          <b-tab
            v-if="Number(form.is_transfer_slip) !== 1"
            title="ประเภทใบเสร็จ"
            :disabled="id <= 0"
          >
            <div v-if="id > 0" class="card card-custom gutter-b mt-4">
              <div class="card-header border-0 pt-6">
                <h3 class="card-title align-items-start flex-column">
                  <span class="card-label font-weight-bolder text-dark">
                    ประเภทใบเสร็จของบริษัท
                  </span>
                </h3>
                <div class="card-toolbar d-flex align-items-center">
                  <b-form-checkbox
                    switch
                    class="mr-3 mb-0 receipt-type-toggle"
                    :checked="isReceiptTypeConpanyEnabled"
                    :disabled="receiptTypeToggleSaving"
                    @change="updateReceiptTypeCompanyToggle"
                  >
                    <span class="receipt-type-toggle-label">
                      เปิดการใช้งาน
                    </span>
                  </b-form-checkbox>
                  <b-button
                    variant="primary"
                    :disabled="
                      !isReceiptTypeConpanyEnabled || receiptTypeToggleSaving
                    "
                    @click.prevent="openReceiptTypeModal()"
                  >
                    {{ $t("PAGE.DEFAULT.TABLE.NEW") }}
                  </b-button>
                </div>
              </div>
              <div class="card-body pb-6 pt-0">
                <div class="table-responsive">
                  <b-table
                    :items="companyReceiptTypeRows"
                    :busy.sync="companyReceiptTypeBusy"
                    :fields="[
                      { key: 'name', label: 'ชื่อ' },
                      {
                        key: 'limit_validator',
                        label: 'จำนวนขั้นต่ำตัวอักษร',
                        tdClass: 'text-center'
                      },
                      {
                        key: 'sort_number',
                        label: 'ลำดับการแสดงผล',
                        tdClass: 'text-center'
                      },
                      {
                        key: 'action',
                        label: $t('PAGE.DEFAULT.TABLE.FIELDS.ACTION.TITLE'),
                        tdClass: 'text-center'
                      }
                    ]"
                    :borderless="true"
                    head-variant="light"
                  >
                    <template #cell(action)="data">
                      <b-button
                        variant="light"
                        size="sm"
                        class="btn-icon"
                        :disabled="
                          !isReceiptTypeConpanyEnabled ||
                          receiptTypeToggleSaving
                        "
                        @click.prevent="openReceiptTypeModal(data.item)"
                      >
                        <span class="svg-icon svg-icon-md svg-icon-success">
                          <inline-svg
                            src="media/svg/icons/General/Edit.svg"
                          ></inline-svg>
                        </span>
                      </b-button>
                      &nbsp;&nbsp;&nbsp;
                      <b-button
                        variant="light"
                        size="sm"
                        class="btn-icon"
                        :disabled="
                          !isReceiptTypeConpanyEnabled ||
                          receiptTypeToggleSaving
                        "
                        @click.prevent="removeCompanyReceiptType(data.item.id)"
                      >
                        <span class="svg-icon svg-icon-md svg-icon-danger">
                          <inline-svg
                            src="media/svg/icons/General/Trash.svg"
                          ></inline-svg>
                        </span>
                      </b-button>
                    </template>
                  </b-table>
                  <p
                    class="text-center pt-3 mb-0"
                    v-if="companyReceiptTypeRows.length < 1"
                  >
                    {{ $t("PAGE.DEFAULT.TABLE.DATA_NOT_FOUND") }}
                  </p>
                </div>
              </div>
            </div>

            <b-modal
              id="company-receipt-type-modal"
              ref="company-receipt-type-modal"
              :title="
                receiptTypeModalMode === 'create'
                  ? 'เพิ่มประเภทใบเสร็จ'
                  : 'แก้ไขประเภทใบเสร็จ'
              "
              :ok-title="$t('PAGE.DEFAULT.FORM.BTN_SUBMIT')"
              :cancel-title="$t('PAGE.DEFAULT.FORM.BTN_CANCEL')"
              @ok="submitCompanyReceiptType"
              @hidden="resetReceiptTypeModal"
            >
              <b-row class="mb-4">
                <b-col sm="4"><h6>ชื่อ</h6></b-col>
                <b-col sm="8">
                  <b-form-input
                    v-model="$v.receiptTypeModal.name.$model"
                    :state="validateReceiptTypeState('name')"
                  />
                  <b-form-invalid-feedback>
                    {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>

              <b-row class="mb-4">
                <b-col sm="4"><h6>จำนวนขั้นต่ำตัวอักษร</h6></b-col>
                <b-col sm="8">
                  <b-form-input
                    type="number"
                    min="1"
                    v-model.number="$v.receiptTypeModal.limit_validator.$model"
                    :state="validateReceiptTypeState('limit_validator')"
                  />
                </b-col>
              </b-row>

              <b-row class="mb-4">
                <b-col sm="4"><h6>สีกราฟ</h6></b-col>
                <b-col sm="8">
                  <b-form-input
                    type="color"
                    v-model="receiptTypeModal.graph_color"
                  />
                </b-col>
              </b-row>

              <b-row class="mb-4" v-if="receiptTypePreview.logo_image">
                <b-col sm="4"></b-col>
                <b-col sm="8">
                  <img
                    class="receipt-image-preview"
                    :src="receiptTypePreview.logo_image"
                  />
                </b-col>
              </b-row>
              <b-row class="mb-4">
                <b-col sm="4"><h6>รูปโลโก้</h6></b-col>
                <b-col sm="8">
                  <b-form-file
                    v-model="$v.receiptTypeModal.logo_image_file.$model"
                    accept="image/*"
                    @change="
                      handleCompanyReceiptTypeImage($event, 'logo_image')
                    "
                    :state="validateReceiptTypeState('logo_image_file')"
                  />
                </b-col>
              </b-row>

              <b-row class="mb-4" v-if="receiptTypePreview.preview_image">
                <b-col sm="4"></b-col>
                <b-col sm="8">
                  <img
                    class="receipt-image-preview"
                    :src="receiptTypePreview.preview_image"
                  />
                </b-col>
              </b-row>
              <b-row class="mb-4">
                <b-col sm="4"><h6>รูปตัวอย่าง</h6></b-col>
                <b-col sm="8">
                  <b-form-file
                    v-model="$v.receiptTypeModal.preview_image_file.$model"
                    accept="image/*"
                    @change="
                      handleCompanyReceiptTypeImage($event, 'preview_image')
                    "
                    :state="validateReceiptTypeState('preview_image_file')"
                  />
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="4">
                  <h6>
                    {{ $t("PAGE.RECEIPT_TYPE.FORM.FIELDS.OCR_SYSTEM_PROMPT") }}
                  </h6>
                </b-col>
                <b-col sm="8">
                  <div class="d-flex align-items-center mb-2">
                    <b-form-file
                      v-model="generateReceiptTypeImageFiles"
                      multiple
                      accept="image/*"
                      placeholder="เลือกรูปใบเสร็จตัวอย่าง (สูงสุด 20 รูป)"
                      class="mr-2 flex-grow-1"
                    />
                    <b-button
                      size="sm"
                      variant="outline-primary"
                      :disabled="
                        !generateReceiptTypeImageFiles.length ||
                        isGeneratingReceiptTypePrompt
                      "
                      @click.prevent="generateCompanyReceiptTypePrompt()"
                    >
                      <span v-if="isGeneratingReceiptTypePrompt">
                        <b-spinner small></b-spinner>
                      </span>
                      <span v-else>สร้าง Prompt</span>
                    </b-button>
                  </div>
                  <small class="text-muted d-block mb-2">
                    อัปโหลดรูปใบเสร็จตัวอย่าง แล้วกด "สร้าง Prompt" — AI
                    จะวิเคราะห์รูปแบบและสร้าง prompt ให้
                  </small>
                  <b-form-textarea
                    v-model="receiptTypeModal.ocr_system_prompt"
                    rows="6"
                    max-rows="20"
                    placeholder="คำแนะนำสำหรับ AI อ่านใบเสร็จประเภทนี้ หรือกด 'สร้าง Prompt' ด้านบน"
                  />
                </b-col>
              </b-row>
            </b-modal>
          </b-tab>

          <b-tab
            v-if="Number(form.is_transfer_slip) === 1"
            title="ข้อมูลธนาคาร"
            :disabled="id <= 0"
          >
            <div v-if="id > 0" class="card card-custom gutter-b mt-4">
              <div class="card-header border-0 pt-6">
                <h3 class="card-title align-items-start flex-column">
                  <span class="card-label font-weight-bolder text-dark">
                    ข้อมูลบัญชีธนาคาร
                  </span>
                </h3>
                <div class="card-toolbar d-flex align-items-center">
                  <b-button
                    variant="primary"
                    @click.prevent="openBankAccountModal()"
                  >
                    {{ $t("PAGE.DEFAULT.TABLE.NEW") }}
                  </b-button>
                </div>
              </div>
              <div class="card-body pb-6 pt-0">
                <div class="col-lg-6 p-0 mb-3">
                  <b-input-group size="sm">
                    <b-form-input
                      v-model="bankAccountPagination.filter"
                      :placeholder="$t('PAGE.DEFAULT.TABLE.SEARCH')"
                      type="search"
                      debounce="500"
                      @update="onBankAccountFilterChange()"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        :disabled="!bankAccountPagination.filter"
                        @click="
                          bankAccountPagination.filter = '';
                          onBankAccountFilterChange();
                        "
                        >{{ $t("PAGE.DEFAULT.TABLE.CLEAR") }}</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </div>

                <div class="table-responsive">
                  <b-table
                    :items="bankAccountRows"
                    :busy.sync="bankAccountBusy"
                    :fields="[
                      { key: 'bank_name', label: 'ชื่อธนาคาร' },
                      { key: 'account_name', label: 'ชื่อบัญชีรับ' },
                      { key: 'account_number', label: 'เลขบัญชี' },
                      {
                        key: 'action',
                        label: $t('PAGE.DEFAULT.TABLE.FIELDS.ACTION.TITLE'),
                        tdClass: 'text-center'
                      }
                    ]"
                    :borderless="true"
                    head-variant="light"
                  >
                    <template #cell(bank_name)="data">
                      {{ bankNameLabel(data.item.bank_name) }}
                    </template>
                    <template #cell(action)="data">
                      <b-button
                        variant="light"
                        size="sm"
                        class="btn-icon"
                        :aria-label="
                          $t('PAGE.DEFAULT.TABLE.FIELDS.ACTION.EDIT')
                        "
                        @click.prevent="openBankAccountModal(data.item)"
                      >
                        <span class="svg-icon svg-icon-md svg-icon-success">
                          <inline-svg
                            src="media/svg/icons/General/Edit.svg"
                          ></inline-svg>
                        </span>
                      </b-button>
                      &nbsp;&nbsp;&nbsp;
                      <b-button
                        variant="light"
                        size="sm"
                        class="btn-icon"
                        :aria-label="
                          $t('PAGE.DEFAULT.TABLE.FIELDS.ACTION.DELETE.TITLE')
                        "
                        @click.prevent="removeBankAccount(data.item.id)"
                      >
                        <span class="svg-icon svg-icon-md svg-icon-danger">
                          <inline-svg
                            src="media/svg/icons/General/Trash.svg"
                          ></inline-svg>
                        </span>
                      </b-button>
                    </template>
                  </b-table>
                  <p
                    class="text-center pt-3 mb-0"
                    v-if="bankAccountRows.length < 1"
                  >
                    {{ $t("PAGE.DEFAULT.TABLE.DATA_NOT_FOUND") }}
                  </p>
                </div>

                <div class="row justify-content-between mt-3">
                  <div class="col-lg-3">
                    <b-form-group
                      :label="$t('PAGE.DEFAULT.TABLE.PER_PAGE')"
                      label-cols="7"
                      label-align-sm="left"
                      label-size="lg"
                    >
                      <b-form-select
                        v-model="bankAccountPagination.perPage"
                        size="sm"
                        :options="bankAccountPerPageOptions"
                        @change="onBankAccountPerPageChange()"
                      ></b-form-select>
                    </b-form-group>
                  </div>
                  <div class="col-lg-3">
                    <b-pagination
                      v-model="bankAccountPagination.page"
                      :total-rows="bankAccountTotal"
                      :per-page="bankAccountPagination.perPage"
                      align="right"
                      @input="loadBankAccountSection()"
                    ></b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>

          <b-tab title="AI Top-up" :disabled="id <= 0">
            <div v-if="id > 0" class="card card-custom gutter-b mt-4">
              <div class="card-header border-0 pt-6">
                <h3 class="card-title align-items-start flex-column">
                  <span class="card-label font-weight-bolder text-dark">
                    AI Top-up
                  </span>
                </h3>
              </div>
              <div class="card-body pb-6 pt-0">
                <div class="col-lg-11">
                  <p class="text-muted small mb-3">
                    Add quota via standard pack or custom credits. Each top-up
                    has its own expiry date.
                  </p>

                  <b-row class="mb-3">
                    <b-col sm="2"><h5>Mode</h5></b-col>
                    <b-col sm="10">
                      <b-form-radio-group
                        v-model="topupMode"
                        :options="[
                          { text: 'Standard pack', value: 'pack' },
                          { text: 'Custom', value: 'custom' }
                        ]"
                        buttons
                        button-variant="outline-primary"
                        size="sm"
                      />
                    </b-col>
                  </b-row>

                  <b-row class="mb-3" v-if="topupMode === 'pack'">
                    <b-col sm="2"><h5>Pack</h5></b-col>
                    <b-col sm="10">
                      <b-form-select
                        v-model="topupPackCode"
                        :options="topupPackOptions"
                        :disabled="topupLoading"
                      />
                    </b-col>
                  </b-row>

                  <b-row class="mb-3" v-else>
                    <b-col sm="2"><h5>Credits</h5></b-col>
                    <b-col sm="10">
                      <b-form-input
                        v-model.number="topupCustomCredits"
                        type="number"
                        min="1"
                        :disabled="topupLoading"
                        placeholder="Enter custom credits"
                      />
                    </b-col>
                  </b-row>

                  <b-row class="mb-3">
                    <b-col sm="2"><h5>Expires At</h5></b-col>
                    <b-col sm="10">
                      <b-form-input
                        v-model="topupExpiresAt"
                        type="datetime-local"
                        :disabled="topupLoading"
                      />
                    </b-col>
                  </b-row>

                  <b-row class="mb-3">
                    <b-col sm="2"><h5>Note</h5></b-col>
                    <b-col sm="10">
                      <b-form-textarea
                        v-model="topupNote"
                        rows="2"
                        max-rows="4"
                        :disabled="topupLoading"
                        placeholder="Optional note for audit"
                      />
                    </b-col>
                  </b-row>

                  <b-row class="mb-4">
                    <b-col sm="2"></b-col>
                    <b-col sm="10">
                      <b-button
                        variant="outline-primary"
                        :disabled="topupLoading"
                        @click.prevent="submitTopup"
                      >
                        Apply Top-up
                      </b-button>
                    </b-col>
                  </b-row>

                  <template v-if="topupSummary">
                    <b-row class="mb-2">
                      <b-col sm="2"><h5>Summary</h5></b-col>
                      <b-col sm="10">
                        <div class="text-muted small">
                          month: {{ topupSummary.year_month }} | plan:
                          {{ topupSummary.plan_ai_quota_per_month }} | top-up
                          active: {{ topupSummary.active_topup_credits }} |
                          used: {{ topupSummary.used_count }} | remaining:
                          {{ topupSummary.remaining }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col sm="2"><h5>Latest logs</h5></b-col>
                      <b-col sm="10">
                        <ul class="small mb-0 pl-4">
                          <li
                            v-for="row in (
                              topupSummary.recent_logs || []
                            ).slice(0, 5)"
                            :key="row.id"
                          >
                            {{ row.action }} ({{ row.delta_credits }}) at
                            {{ row.created_at }}
                          </li>
                        </ul>
                      </b-col>
                    </b-row>
                  </template>
                </div>
              </div>
            </div>
          </b-tab>

          <b-tab title="สีพื้นหลักและปุ่มกด" :disabled="id <= 0">
            <div v-if="id > 0" class="card card-custom gutter-b mt-4">
              <div class="card-header border-0 pt-6">
                <h3 class="card-title align-items-start flex-column">
                  <span class="card-label font-weight-bolder text-dark">
                    สีพื้นหลักและปุ่มกด
                  </span>
                </h3>
              </div>
              <div class="card-body pb-6 pt-0">
                <custom-color :company-id="id" :embedded="true" />
              </div>
            </div>
          </b-tab>

          <b-tab title="การสมัครสมาชิก" :disabled="id <= 0">
            <div v-if="id > 0">
              <company-registration-setting :company-id="id" />
            </div>
          </b-tab>
        </b-tabs>
      </b-card>

      <b-modal
        id="company-bank-account-modal"
        ref="company-bank-account-modal"
        :title="
          bankAccountModalMode === 'create'
            ? 'เพิ่มข้อมูลธนาคาร'
            : 'แก้ไขข้อมูลธนาคาร'
        "
        :ok-title="$t('PAGE.DEFAULT.FORM.BTN_SUBMIT')"
        :cancel-title="$t('PAGE.DEFAULT.FORM.BTN_CANCEL')"
        @ok="submitBankAccount"
        @hidden="resetBankAccountModal"
      >
        <b-row class="mb-4">
          <b-col sm="4"><h6>ชื่อธนาคาร</h6></b-col>
          <b-col sm="8">
            <b-form-select
              v-model="$v.bankAccountModal.bank_name.$model"
              :options="bankOptions"
              :state="validateBankAccountState('bank_name')"
            >
              <template #first>
                <b-form-select-option :value="''" disabled>
                  เลือกธนาคาร
                </b-form-select-option>
              </template>
            </b-form-select>
            <b-form-invalid-feedback
              :state="validateBankAccountState('bank_name')"
            >
              {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
            </b-form-invalid-feedback>
          </b-col>
        </b-row>

        <b-row class="mb-4">
          <b-col sm="4"><h6>ชื่อบัญชีรับ</h6></b-col>
          <b-col sm="8">
            <b-form-input
              v-model="$v.bankAccountModal.account_name.$model"
              :state="validateBankAccountState('account_name')"
            />
            <b-form-invalid-feedback>
              {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
            </b-form-invalid-feedback>
          </b-col>
        </b-row>

        <b-row class="mb-4">
          <b-col sm="4"><h6>เลขบัญชี</h6></b-col>
          <b-col sm="8">
            <b-form-input
              v-model="$v.bankAccountModal.account_number.$model"
              :state="validateBankAccountState('account_number')"
              :formatter="formatBankAccountNumber"
              inputmode="numeric"
            />
            <b-form-invalid-feedback
              :state="validateBankAccountState('account_number')"
            >
              <span v-if="!$v.bankAccountModal.account_number.required">
                {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
              </span>
              <span v-else>กรุณากรอกเฉพาะตัวเลขเท่านั้น</span>
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </b-modal>
    </div>
  </div>
</template>
<style>
.logo-image-preview {
  margin-left: 30%;
  width: 120px;
  height: 120px;
  object-fit: cover;
  object-position: center;
  border: solid 1px #ccc;
  border-radius: 100%;
}

.receipt-image-preview {
  width: 120px;
  height: 120px;
  object-fit: cover;
  object-position: center;
  border: solid 1px #ccc;
  border-radius: 12px;
}

.receipt-type-toggle {
  display: flex;
  align-items: center;
}

.receipt-type-toggle-label {
  color: #f64e60;
  font-weight: 600;
}
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ApiService from "@/core/services/api.service";
import CustomColor from "@/view/pages/custom-color/CustomColor.vue";
import CompanyRegistrationSetting from "@/view/pages/company-management/CompanyRegistrationSetting.vue";
import { validationMixin } from "vuelidate";
import {
  required,
  maxLength,
  requiredIf,
  integer,
  minValue,
  numeric
} from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import {
  POST_COMPANY_MANAGEMENT_DATA,
  SET_IS_CLEAR_PAGINATION,
  GET_COMPANY_MANAGEMENT_DATA,
  PUT_COMPANY_MANAGEMENT_DATA,
  LIST_PLANS,
  GET_COMPANY_PLAN,
  PUT_COMPANY_PLAN,
  LIST_TOPUP_PACKS,
  GET_COMPANY_TOPUP,
  POST_COMPANY_TOPUP,
  LIST_COMPANY_RECEIPT_TYPE,
  CREATE_COMPANY_RECEIPT_TYPE,
  UPDATE_COMPANY_RECEIPT_TYPE,
  DELETE_COMPANY_RECEIPT_TYPE,
  PAGINATION_COMPANY_BANK_ACCOUNT,
  CREATE_COMPANY_BANK_ACCOUNT,
  UPDATE_COMPANY_BANK_ACCOUNT,
  DELETE_COMPANY_BANK_ACCOUNT
} from "@/core/services/store/company_management.module";
import { GENERATE_OCR_PROMPT } from "@/core/services/store/receipt_type.module";

export default {
  components: { CustomColor, CompanyRegistrationSetting },
  mixins: [validationMixin],
  data() {
    return {
      //value: [],
      id: 0,
      form: {
        name: "",
        logo_image: null,
        is_transfer_slip: 0
      },
      preview_image: null,
      preview: null,
      planLoading: false,
      planRows: [],
      selectedPlanId: null,
      planExpiresAt: "",
      topupLoading: false,
      topupPackRows: [],
      topupSummary: null,
      topupMode: "pack",
      topupPackCode: null,
      topupCustomCredits: null,
      topupExpiresAt: "",
      topupNote: "",
      companyReceiptTypeRows: [],
      companyReceiptTypeBusy: false,
      receiptTypeModalMode: "create",
      receiptTypeModal: {
        id: null,
        name: "",
        limit_validator: 1,
        sort_number: 0,
        graph_color: "#00B14F",
        ocr_system_prompt: null,
        logo_image: null,
        logo_image_file: [],
        preview_image: null,
        preview_image_file: []
      },
      generateReceiptTypeImageFiles: [],
      isGeneratingReceiptTypePrompt: false,
      receiptTypePreview: {
        logo_image: null,
        preview_image: null
      },
      receiptTypeExistingImagePath: {
        logo_image: null,
        preview_image: null
      },
      isReceiptTypeConpanyEnabled: true,
      receiptTypeToggleSaving: false,
      bankAccountRows: [],
      bankAccountBusy: false,
      bankAccountTotal: 0,
      bankAccountPagination: {
        page: 1,
        perPage: 10,
        filter: ""
      },
      bankAccountPerPageOptions: [10, 25, 50, 100],
      bankAccountModalMode: "create",
      bankAccountModal: {
        id: null,
        bank_name: "",
        account_name: "",
        account_number: ""
      },
      bankList: []
    };
  },
  validations: {
    form: {
      name: {
        required,
        maxLength: maxLength(256)
      },
      logo_image: {
        required: requiredIf(function () {
          return !this.id;
        })
      }
    },
    receiptTypeModal: {
      name: {
        required,
        maxLength: maxLength(256)
      },
      limit_validator: {
        required,
        integer,
        minValue: minValue(1)
      },
      sort_number: {
        required,
        integer,
        minValue: minValue(0)
      },
      logo_image_file: {
        required: requiredIf(function () {
          return (
            this.receiptTypeModalMode === "create" &&
            !this.receiptTypeModal.logo_image
          );
        })
      },
      preview_image_file: {
        required: requiredIf(function () {
          return (
            this.receiptTypeModalMode === "create" &&
            !this.receiptTypeModal.preview_image
          );
        })
      }
    },
    bankAccountModal: {
      bank_name: { required },
      account_name: { required },
      account_number: { required, numeric }
    }
  },
  computed: {
    uploadModeOptions() {
      return [
        { value: 0, text: "ใบเสร็จ" },
        { value: 1, text: "สลิปโอนเงิน" }
      ];
    },
    planSelectOptions() {
      const rows = this.planRows || [];
      return rows.map((p) => ({
        value: p.id,
        text: `${p.name} (${p.slug})`
      }));
    },
    topupPackOptions() {
      return (this.topupPackRows || []).map((p) => ({
        value: p.code,
        text: `${p.code} - ${p.credits} credits (${p.default_validity_days} days)`
      }));
    },
    bankOptions() {
      return this.bankList;
    }
  },
  watch: {
    "form.is_transfer_slip"(value) {
      if (Number(value) === 1 && this.id > 0) {
        this.loadBankAccountSection();
      }
    }
  },
  mounted() {
    this.loadBankList();

    const raw = this.$route.params.id;
    this.id = raw !== undefined && raw !== null && raw !== "" ? Number(raw) : 0;
    if (Number.isNaN(this.id)) {
      this.id = 0;
    }

    if (this.id > 0) {
      this.$store.dispatch(SET_BREADCRUMB, [
        {
          title: `${this.$t("MENU.COMPANY_MANAGEMENT.TITLE")}`,
          route: "../../company-management"
        },
        { title: `${this.$t("PAGE.DEFAULT.FORM.TITLE")}` }
      ]);

      this.getCompany(this.id);
    } else {
      this.$store.dispatch(SET_BREADCRUMB, [
        {
          title: `${this.$t("MENU.COMPANY_MANAGEMENT.TITLE")}`,
          route: "../company-management"
        },
        { title: `${this.$t("PAGE.DEFAULT.FORM.TITLE")}` }
      ]);
      this.loadPlanSection();
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    validateReceiptTypeState(name) {
      const item = this.$v.receiptTypeModal[name];
      if (!item) {
        return null;
      }
      const { $dirty, $error } = item;
      return $dirty ? !$error : null;
    },
    resetReceiptTypeModal() {
      this.receiptTypeModalMode = "create";
      this.receiptTypeModal = {
        id: null,
        name: "",
        limit_validator: 1,
        sort_number: 0,
        graph_color: "#00B14F",
        ocr_system_prompt: null,
        logo_image: null,
        logo_image_file: [],
        preview_image: null,
        preview_image_file: []
      };
      this.generateReceiptTypeImageFiles = [];
      this.isGeneratingReceiptTypePrompt = false;
      this.receiptTypePreview = {
        logo_image: null,
        preview_image: null
      };
      this.receiptTypeExistingImagePath = {
        logo_image: null,
        preview_image: null
      };
      this.$nextTick(() => {
        if (this.$v && this.$v.receiptTypeModal) {
          this.$v.receiptTypeModal.$reset();
        }
      });
    },
    openReceiptTypeModal(item = null) {
      if (!this.isReceiptTypeConpanyEnabled) {
        return;
      }
      this.resetReceiptTypeModal();
      if (item) {
        this.receiptTypeModalMode = "update";
        this.receiptTypeModal.id = item.id;
        this.receiptTypeModal.name = item.name || "";
        this.receiptTypeModal.limit_validator = Number(
          item.limit_validator || 1
        );
        this.receiptTypeModal.sort_number = Number(item.sort_number || 0);
        this.receiptTypeModal.graph_color = item.graph_color || "#00B14F";
        this.receiptTypeModal.ocr_system_prompt =
          item.ocr_system_prompt || null;
        this.receiptTypeModal.logo_image = item.logo_image || null;
        this.receiptTypeModal.preview_image = item.preview_image || null;
        this.receiptTypeExistingImagePath.logo_image = item.logo_image || null;
        this.receiptTypeExistingImagePath.preview_image =
          item.preview_image || null;
        this.receiptTypePreview.logo_image = item.logo_image
          ? `${process.env.VUE_APP_IMAGE}${item.logo_image}`
          : null;
        this.receiptTypePreview.preview_image = item.preview_image
          ? `${process.env.VUE_APP_IMAGE}${item.preview_image}`
          : null;
      }
      this.$refs["company-receipt-type-modal"].show();
    },
    handleCompanyReceiptTypeImage(event, field) {
      const selectedImage = event.target.files[0];
      if (!selectedImage) {
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        this.receiptTypeModal[field] = e.target.result;
        this.receiptTypePreview[field] = e.target.result;
      };
      reader.readAsDataURL(selectedImage);
    },
    rtFileToDataUrl(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    // ย่อรูปด้วย canvas ก่อนแปลง base64 (ลดขนาด payload + ประหยัด token)
    async rtDownscaleImage(file, maxEdge = 1600, quality = 0.85) {
      const dataUrl = await this.rtFileToDataUrl(file);
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          let { width, height } = img;
          const longest = Math.max(width, height);
          if (longest > maxEdge) {
            const scale = maxEdge / longest;
            width = Math.round(width * scale);
            height = Math.round(height * scale);
          }
          try {
            const canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);
            resolve(canvas.toDataURL("image/jpeg", quality));
          } catch (e) {
            resolve(dataUrl);
          }
        };
        img.onerror = () => resolve(dataUrl);
        img.src = dataUrl;
      });
    },
    async generateCompanyReceiptTypePrompt() {
      if (
        !this.generateReceiptTypeImageFiles.length ||
        this.isGeneratingReceiptTypePrompt
      ) {
        return;
      }
      this.isGeneratingReceiptTypePrompt = true;
      try {
        const files = Array.from(this.generateReceiptTypeImageFiles).slice(
          0,
          20
        );
        const images = await Promise.all(
          files.map((f) => this.rtDownscaleImage(f))
        );

        const { data } = await this.$store.dispatch(GENERATE_OCR_PROMPT, {
          data: { images }
        });

        if (data.status === "success" && data.data && data.data.prompt) {
          this.receiptTypeModal.ocr_system_prompt = data.data.prompt;
          this.generateReceiptTypeImageFiles = [];
          Swal.fire({
            icon: "success",
            text: "สร้าง Prompt สำเร็จ กรุณาตรวจสอบและแก้ไขก่อนบันทึก",
            timer: 3000,
            showConfirmButton: false
          });
        } else {
          Swal.fire({
            icon: "error",
            text:
              (data && data.error) || "ไม่สามารถสร้าง Prompt ได้ กรุณาลองใหม่",
            confirmButtonText: "ตกลง"
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          text: String(error),
          confirmButtonText: "ตกลง"
        });
      } finally {
        this.isGeneratingReceiptTypePrompt = false;
      }
    },
    async submitCompanyReceiptType(modalEvent) {
      if (!this.isReceiptTypeConpanyEnabled) {
        modalEvent.preventDefault();
        return;
      }
      modalEvent.preventDefault();
      this.$v.receiptTypeModal.$touch();
      if (this.$v.receiptTypeModal.$anyError) {
        return;
      }

      const payload = {
        name: this.receiptTypeModal.name,
        limit_validator: this.receiptTypeModal.limit_validator,
        graph_color: this.receiptTypeModal.graph_color,
        ocr_system_prompt: this.receiptTypeModal.ocr_system_prompt,
        logo_image: this.receiptTypeModal.logo_image,
        preview_image: this.receiptTypeModal.preview_image
      };

      const action =
        this.receiptTypeModalMode === "create"
          ? CREATE_COMPANY_RECEIPT_TYPE
          : UPDATE_COMPANY_RECEIPT_TYPE;
      const dispatchPayload =
        this.receiptTypeModalMode === "create"
          ? { id: this.id, data: payload }
          : {
              id: this.id,
              receiptTypeId: this.receiptTypeModal.id,
              data: payload
            };

      try {
        const { data } = await this.$store.dispatch(action, dispatchPayload);
        if (data.status === "success") {
          this.$refs["company-receipt-type-modal"].hide();
          Swal.fire({
            icon: "success",
            text: `${this.$t("RESPONSE_MESSAGE.SAVE_DATA_SUCCESS")}`
          });
          this.loadCompanyReceiptTypeSection();
        } else if (data.status === "error" && data.error) {
          Swal.fire({
            icon: "error",
            text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          text: String(error)
        });
      }
    },
    async loadCompanyReceiptTypeSection() {
      if (!this.id) {
        return;
      }

      this.companyReceiptTypeBusy = true;
      try {
        const { data } = await this.$store.dispatch(LIST_COMPANY_RECEIPT_TYPE, {
          id: this.id
        });
        if (data.status === "success" && data.data) {
          this.companyReceiptTypeRows = Array.isArray(data.data)
            ? data.data
            : [];
        } else {
          this.companyReceiptTypeRows = [];
        }
      } catch (error) {
        this.companyReceiptTypeRows = [];
      } finally {
        this.companyReceiptTypeBusy = false;
      }
    },
    removeCompanyReceiptType(receiptTypeId) {
      if (!this.isReceiptTypeConpanyEnabled) {
        return;
      }
      Swal.fire({
        text: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.ACTION.DELETE.DESC")}`,
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
        cancelButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_CANCEL")}`
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch(DELETE_COMPANY_RECEIPT_TYPE, {
              id: this.id,
              receiptTypeId
            })
            .then(({ data }) => {
              if (data.status === "success") {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE.DELETE_DATA_SUCCESS")}`
                });
                this.loadCompanyReceiptTypeSection();
              } else if (data.status === "error" && data.error) {
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                text: String(error)
              });
            });
        }
      });
    },
    onPlanFormSubmit() {
      if (this.id > 0) {
        this.savePlan();
      }
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      let formData = new FormData();
      formData.append("name", this.form.name);
      if (this.form.logo_image instanceof File) {
        formData.append("logo_image", this.form.logo_image);
      }
      formData.append("is_transfer_slip", String(this.form.is_transfer_slip));
      if (!this.id && this.selectedPlanId) {
        formData.append("plan_id", String(this.selectedPlanId));
      }
      if (!this.id && this.planExpiresAt) {
        formData.append("expires_at", this.planExpiresAt);
      }
      this.id > 0 ? this.update(this.id, formData) : this.create(formData);
    },

    create(data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(POST_COMPANY_MANAGEMENT_DATA, { data })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                Swal.fire({
                  icon: "success",
                  text: `สร้างข้อมูลเรียบร้อยแล้ว`
                });
                this.$router.push("../company-management");
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
              }
            })
            .catch((error) => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
              });
            });
        }
      });
    },

    getCompany(id) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(GET_COMPANY_MANAGEMENT_DATA, { id })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                for (const formKey of Object.keys(this.form)) {
                  if (formKey === "logo_image") {
                    continue;
                  }
                  for (const dataKey of Object.keys(data.data)) {
                    if (formKey === dataKey) {
                      this.form[formKey] = data.data[formKey];
                    }
                  }
                }
                this.form.is_transfer_slip =
                  Number(data.data.is_transfer_slip) === 1 ? 1 : 0;
                if (data.data.logo_image) {
                  this.preview_image = `${process.env.VUE_APP_IMAGE}${data.data.logo_image}`;
                } else {
                  this.preview_image = "media/company/default.png";
                }
                this.isReceiptTypeConpanyEnabled =
                  Number(data.data.is_receipt_type_conpany) !== 0;
                this.loadPlanSection();
                this.loadTopupSection();
                this.loadCompanyReceiptTypeSection();
                if (Number(this.form.is_transfer_slip) === 1) {
                  this.loadBankAccountSection();
                }
              } else if (data.status === "error" && data.error) {
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
              }
            })
            .catch((error) => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
              });
            });
        }
      });
    },
    async updateReceiptTypeCompanyToggle(checked) {
      if (!this.id || this.receiptTypeToggleSaving) {
        return;
      }

      const nextValue = checked ? 1 : 0;
      const prevValue = this.isReceiptTypeConpanyEnabled;
      this.isReceiptTypeConpanyEnabled = checked;
      this.receiptTypeToggleSaving = true;

      const formData = new FormData();
      formData.append("name", this.form.name);
      formData.append("is_receipt_type_conpany", String(nextValue));
      formData.append("is_transfer_slip", String(this.form.is_transfer_slip));

      try {
        const { data } = await this.$store.dispatch(
          PUT_COMPANY_MANAGEMENT_DATA,
          {
            id: this.id,
            data: formData
          }
        );
        if (data.status === "success") {
          return;
        }

        this.isReceiptTypeConpanyEnabled = prevValue;
        if (data.status === "error" && data.error) {
          Swal.fire({
            icon: "error",
            text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`
          });
        }
      } catch (error) {
        this.isReceiptTypeConpanyEnabled = prevValue;
        Swal.fire({
          icon: "error",
          text: String(error)
        });
      } finally {
        this.receiptTypeToggleSaving = false;
      }
    },

    update(id, data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(PUT_COMPANY_MANAGEMENT_DATA, { id, data })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
                this.$router.push("../../company-management");
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
              }
            })
            .catch((error) => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
              });
            });
        }
      });
    },
    cancel() {
      this.$store.commit(SET_IS_CLEAR_PAGINATION, { isClearPagination: false });
      this.$router.push(
        this.id > 0 ? "../../company-management" : "../company-management"
      );
    },

    loadFile(event) {
      try {
        this.preview = URL.createObjectURL(event.target.files[0]);
      } catch {
        this.preview = null;
      }
    },

    async loadPlanSection() {
      this.planLoading = true;
      try {
        const plansRes = await this.$store.dispatch(LIST_PLANS);
        const pd = plansRes.data;
        let rows = [];
        if (pd.status === "success" && pd.data) {
          const d = pd.data;
          rows = d.rows || d;
        }
        this.planRows = Array.isArray(rows) ? rows : [];

        const starter = this.planRows.find((r) => r.slug === "starter");
        const defaultPlanId = starter
          ? starter.id
          : this.planRows.length
          ? this.planRows[0].id
          : null;

        if (!this.id) {
          this.selectedPlanId = defaultPlanId;
          this.planExpiresAt = "";
          return;
        }

        const capRes = await this.$store.dispatch(GET_COMPANY_PLAN, {
          id: this.id
        });
        const cd = capRes.data;
        if (cd.status === "success" && cd.data) {
          const cp = cd.data.company_plan;
          if (cp && cp.plan_id) {
            this.selectedPlanId = cp.plan_id;
          } else {
            this.selectedPlanId = defaultPlanId;
          }
          if (cp && cp.expires_at) {
            const dt = new Date(cp.expires_at);
            if (!Number.isNaN(dt.getTime())) {
              this.planExpiresAt = dt.toISOString().slice(0, 10);
            }
          } else {
            this.planExpiresAt = "";
          }
        }
      } catch (e) {
        const msg =
          e && e.response && e.response.data && e.response.data.message
            ? e.response.data.message
            : this.$t("RESPONSE_MESSAGE.ERROR_OCCURRED");
        Swal.fire({
          icon: "error",
          text: String(msg)
        });
      } finally {
        this.planLoading = false;
      }
    },
    async loadTopupSection() {
      if (!this.id) {
        return;
      }
      this.topupLoading = true;
      try {
        const [catalogRes, summaryRes] = await Promise.all([
          this.$store.dispatch(LIST_TOPUP_PACKS),
          this.$store.dispatch(GET_COMPANY_TOPUP, { id: this.id })
        ]);

        const catalogData = catalogRes.data;
        if (catalogData.status === "success" && catalogData.data) {
          this.topupPackRows = Array.isArray(catalogData.data)
            ? catalogData.data
            : [];
          this.topupPackCode = this.topupPackRows.length
            ? this.topupPackRows[0].code
            : null;
        } else {
          this.topupPackRows = [];
          this.topupPackCode = null;
        }

        const summaryData = summaryRes.data;
        if (summaryData.status === "success" && summaryData.data) {
          this.topupSummary = summaryData.data;
        } else {
          this.topupSummary = null;
        }
      } catch (e) {
        const msg =
          e && e.response && e.response.data && e.response.data.message
            ? e.response.data.message
            : this.$t("RESPONSE_MESSAGE.ERROR_OCCURRED");
        Swal.fire({
          icon: "error",
          text: String(msg)
        });
      } finally {
        this.topupLoading = false;
      }
    },
    async submitTopup() {
      if (!this.id) {
        return;
      }
      const payload = {};
      if (this.topupMode === "pack") {
        if (!this.topupPackCode) {
          Swal.fire({
            icon: "warning",
            text: "Please select top-up pack"
          });
          return;
        }
        payload.pack_code = this.topupPackCode;
        if (this.topupExpiresAt) {
          payload.expires_at = this.topupExpiresAt;
        }
      } else {
        const n = Number(this.topupCustomCredits);
        if (!Number.isFinite(n) || n <= 0) {
          Swal.fire({
            icon: "warning",
            text: "Custom credits must be greater than 0"
          });
          return;
        }
        if (!this.topupExpiresAt) {
          Swal.fire({
            icon: "warning",
            text: "Please select expiry date"
          });
          return;
        }
        payload.credit_amount = Math.floor(n);
        payload.expires_at = this.topupExpiresAt;
      }
      if (this.topupNote) {
        payload.note = this.topupNote;
      }

      this.topupLoading = true;
      try {
        const { data } = await this.$store.dispatch(POST_COMPANY_TOPUP, {
          id: this.id,
          data: payload
        });
        if (data.status === "success") {
          Swal.fire({
            icon: "success",
            text: "Top-up added successfully"
          });
          this.topupCustomCredits = null;
          this.topupNote = "";
          this.topupExpiresAt = "";
          await this.loadTopupSection();
        } else if (data.status === "error" && data.error) {
          Swal.fire({
            icon: "error",
            text: this.$t("RESPONSE_MESSAGE." + data.error) || data.error
          });
        }
      } catch (e) {
        Swal.fire({
          icon: "error",
          text: String(e)
        });
      } finally {
        this.topupLoading = false;
      }
    },

    savePlan() {
      if (!this.selectedPlanId) {
        return;
      }
      const payload = {
        plan_id: this.selectedPlanId,
        expires_at: this.planExpiresAt || null
      };
      this.planLoading = true;
      this.$store
        .dispatch(PUT_COMPANY_PLAN, { id: this.id, data: payload })
        .then(({ data }) => {
          this.planLoading = false;
          if (data.status === "success") {
            Swal.fire({
              icon: "success",
              text: this.$t("RESPONSE_MESSAGE.SAVE_DATA_SUCCESS")
            });
            this.loadPlanSection();
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: this.$t("RESPONSE_MESSAGE." + data.error) || data.error
            });
          }
        })
        .catch((error) => {
          this.planLoading = false;
          Swal.fire({
            icon: "error",
            text: String(error)
          });
        });
    },
    loadBankList() {
      ApiService.setHeader();
      ApiService.getParams("master/banks")
        .then((response) => {
          const data = response && response.data ? response.data.data : null;
          this.bankList = Array.isArray(data) ? data : [];
        })
        .catch((error) => {
          this.bankList = [];
          // eslint-disable-next-line no-console
          console.error("loadBankList error", error);
        });
    },
    bankNameLabel(value) {
      const found = this.bankList.find((b) => b.value === value);
      return found ? found.text : value || "-";
    },
    validateBankAccountState(name) {
      const item = this.$v.bankAccountModal[name];
      if (!item) {
        return null;
      }
      const { $dirty, $error } = item;
      return $dirty ? !$error : null;
    },
    getBankAccountParams() {
      return {
        page: this.bankAccountPagination.page.toString(),
        perPage: this.bankAccountPagination.perPage.toString(),
        orderBy: "sort_number",
        sortDirection: "asc",
        filter: this.bankAccountPagination.filter.toString()
      };
    },
    onBankAccountFilterChange() {
      this.bankAccountPagination.page = 1;
      this.loadBankAccountSection();
    },
    onBankAccountPerPageChange() {
      this.bankAccountPagination.page = 1;
      this.loadBankAccountSection();
    },
    async loadBankAccountSection() {
      if (!this.id) {
        return;
      }
      this.bankAccountBusy = true;
      try {
        const { data } = await this.$store.dispatch(
          PAGINATION_COMPANY_BANK_ACCOUNT,
          {
            id: this.id,
            params: this.getBankAccountParams()
          }
        );
        if (data.status === "success" && data.data) {
          this.bankAccountRows = Array.isArray(data.data.data)
            ? data.data.data
            : [];
          this.bankAccountTotal = Number(data.data.total) || 0;
          if (this.bankAccountTotal > 0 && this.bankAccountRows.length < 1) {
            this.bankAccountPagination.page = 1;
            this.bankAccountBusy = false;
            this.loadBankAccountSection();
            return;
          }
        } else {
          this.bankAccountRows = [];
          this.bankAccountTotal = 0;
        }
      } catch (error) {
        this.bankAccountRows = [];
        this.bankAccountTotal = 0;
      } finally {
        this.bankAccountBusy = false;
      }
    },
    resetBankAccountModal() {
      this.bankAccountModalMode = "create";
      this.bankAccountModal = {
        id: null,
        bank_name: "",
        account_name: "",
        account_number: ""
      };
      this.$nextTick(() => {
        if (this.$v && this.$v.bankAccountModal) {
          this.$v.bankAccountModal.$reset();
        }
      });
    },
    openBankAccountModal(item = null) {
      this.resetBankAccountModal();
      if (item) {
        this.bankAccountModalMode = "update";
        this.bankAccountModal.id = item.id;
        this.bankAccountModal.bank_name = item.bank_name || "";
        this.bankAccountModal.account_name = item.account_name || "";
        this.bankAccountModal.account_number = item.account_number || "";
      }
      this.$refs["company-bank-account-modal"].show();
    },
    formatBankAccountNumber(value) {
      return String(value || "").replace(/\D/g, "");
    },
    async submitBankAccount(modalEvent) {
      modalEvent.preventDefault();
      this.$v.bankAccountModal.$touch();
      if (this.$v.bankAccountModal.$anyError) {
        if (
          this.$v.bankAccountModal.account_number.required &&
          !this.$v.bankAccountModal.account_number.numeric
        ) {
          Swal.fire({
            icon: "error",
            text: "เลขบัญชีต้องเป็นตัวเลขเท่านั้น (ห้ามมีตัวอักษร อักขระพิเศษ หรือเว้นวรรค)"
          });
        }
        return;
      }

      const payload = {
        bank_name: this.bankAccountModal.bank_name,
        account_name: this.bankAccountModal.account_name,
        account_number: this.bankAccountModal.account_number
      };

      const action =
        this.bankAccountModalMode === "create"
          ? CREATE_COMPANY_BANK_ACCOUNT
          : UPDATE_COMPANY_BANK_ACCOUNT;
      const dispatchPayload =
        this.bankAccountModalMode === "create"
          ? { id: this.id, data: payload }
          : {
              id: this.id,
              bankAccountId: this.bankAccountModal.id,
              data: payload
            };

      try {
        const { data } = await this.$store.dispatch(action, dispatchPayload);
        if (data.status === "success") {
          this.$refs["company-bank-account-modal"].hide();
          Swal.fire({
            icon: "success",
            text: `${this.$t("RESPONSE_MESSAGE.SAVE_DATA_SUCCESS")}`
          });
          this.loadBankAccountSection();
        } else if (data.status === "error" && data.error) {
          Swal.fire({
            icon: "error",
            text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          text: String(error)
        });
      }
    },
    removeBankAccount(bankAccountId) {
      Swal.fire({
        text: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.ACTION.DELETE.DESC")}`,
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
        cancelButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_CANCEL")}`
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch(DELETE_COMPANY_BANK_ACCOUNT, {
              id: this.id,
              bankAccountId
            })
            .then(({ data }) => {
              if (data.status === "success") {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE.DELETE_DATA_SUCCESS")}`
                });
                this.loadBankAccountSection();
              } else if (data.status === "error" && data.error) {
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                text: String(error)
              });
            });
        }
      });
    }
  }
};
</script>
